// extracted by mini-css-extract-plugin
module.exports = {"addressDisplay":"AddressDisplay_addressDisplay__2iGFz"};